import React from "react";
import { object, bool } from "prop-types";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import SectionAndTimeStamp from "../../molecules/section-and-timestamp";
import SocialShareLinks from "../../molecules/social-share";
import LiveIcon from "../../atoms/icons/live-icon";

import "./header-block.m.css";

const StoryHeader = ({ story, showHeroImage, isLiveBlog }) => (
  <div styleName="story-head" className="story-head">
    {isLiveBlog && !get(story, ["metadata", "is-closed"]) && (
      <span styleName="live-active">
        <LiveIcon />
        Live
      </span>
    )}
    <Headline text={story.headline} headerType={16} />
    {story.summary && <p styleName="summary">{story.summary}</p>}
    <SectionAndTimeStamp story={story} />
    {showHeroImage ? (
      <CardImage
        story={story}
        defaultWidth={710}
        aspectRatio={[16, 9]}
        eager={true}
        imageType="image16x9"
        showImageCaption={true}
      />
    ) : null}
    <SocialShare storyId={story.id} template={SocialShareLinks} title={story.headline} url={story.slug} color="#fff" />
  </div>
);

StoryHeader.propTypes = {
  story: object,
  showHeroImage: bool,
  isLiveBlog: bool,
};

StoryHeader.defaultProps = {
  showHeroImage: true,
  isLiveBlog: false,
};

export default StoryHeader;
